import React, { useState, useEffect } from 'react';
import { auth } from '../services/firebase';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { confirmPasswordReset, verifyPasswordResetCode } from 'firebase/auth';

const AcaoEmail = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // oobCode é o token de ação do Firebase
  const oobCode = searchParams.get('oobCode');

  useEffect(() => {
    if (!oobCode) {
      setMensagem('Código de ação inválido ou ausente.');
      setLoading(false);
      return;
    }
    // Verifica se o código é válido antes de mostrar o formulário
    verifyPasswordResetCode(auth, oobCode)
      .then((email) => {
        console.log('Código válido para o email:', email);
        setLoading(false);
      })
      .catch((error) => {
        setMensagem('O link é inválido ou expirou. Tente redefinir sua senha novamente.');
        setLoading(false);
      });
  }, [oobCode]);

  const handleSalvarSenha = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setMensagem('As senhas não coincidem.');
      return;
    }
    if (!oobCode) {
      setMensagem('Código de ação inválido.');
      return;
    }

    try {
      await confirmPasswordReset(auth, oobCode, password);
      setMensagem('Senha definida/redefinida com sucesso! Você será redirecionado para o login.');
      setTimeout(() => navigate('/'), 3000);
    } catch (error) {
      setMensagem('Erro ao salvar a senha: ' + error.message);
    }
  };

  if (loading) {
    return <div>Verificando link...</div>;
  }

  return (<div>
    <h1>Definir Nova Senha</h1>
    <form onSubmit={handleSalvarSenha}>
      <input type="password" placeholder="Nova Senha" value={password} onChange={(e) => setPassword(e.target.value)} required />
      <input type="password" placeholder="Confirmar Senha" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
      <button type="submit">Salvar Senha</button>
    </form>
    {mensagem && <p>{mensagem}</p>}
  </div>);
};

export default AcaoEmail;